import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import FadeIn from 'react-fade-in/lib/FadeIn';
import Lottie from 'react-lottie';
import { Container } from 'reactstrap';
import * as loadingData from './loadingData.json'

const LoadingData = ({ width = 200, height = 150 }) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingData.default,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setLoading(true)
        },3000)
    },[])

  return (
    <React.Fragment>
        {/* {!loading ?  */}
        <FadeIn>
          <Lottie options={defaultOptions} width={width} height={height} /> 
        </FadeIn>
        {/* // : null} */}
        
    </React.Fragment>
  )
}

export default LoadingData